<template>
  <b-progress height="3rem" :max="progressData.totalAmount" v-if="progressData">
    <b-progress-bar :value="progressData.loaded" variant="success"></b-progress-bar>
    <b-progress-bar :value="progressData.available" variant="info"></b-progress-bar>
    <b-progress-bar :value="progressData.unknownBarcode" variant="warning"></b-progress-bar>
  </b-progress>
</template>

<script>
  export default {
    name: 'progress-bar-out-going-data',
    props: ['cargo', 'progressData']
  }
</script>

<style lang="scss" scoped>
  .progress {
    border: 1px solid #e4e0e0;
  }

  .progress {
    background: white;
  }

  .bg-success {
    background: #00b954 !important;
  }

  .bg-info {
    background: #00c9ff !important
  }
</style>